import type { GatsbyBrowser } from 'gatsby';
import './src/styles/globals.css';
import './src/styles/_reset.scss';
import './src/styles/_variables.scss';

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
    routerProps: { location },
    getSavedScrollPosition,
}) => {
    const currentPosition = getSavedScrollPosition(location);
    window.setTimeout(() => {
        window.scrollTo(...(currentPosition || [0, 0]));
    }, 0);
    return false;
};